import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { Storage } from "@ionic/storage";
import { DataService } from "../common/services/data/data.service";
import { Member, User } from "src/app/common/config/app.classes";
import { CommonAlertComponent } from "../common/alerts/common-alert/common-alert.component";
import { MatDialog } from "@angular/material/dialog";
import { AppSettingsService } from "../common/services/app-settings/app-settings.service";
import { ChangePasswordComponent } from "../start/change-password/change-password.component";
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  user = new User();
  member = new Member();
  loginNameMember: any;
  loginNameUser: any;
  baseAppPath = "";
  loginName: any;
  constructor(
    public data: DataService,
    public storage: Storage,
    public dialog: MatDialog,
    public appSetting: AppSettingsService
  ) {
    this.baseAppPath = this.appSetting.environment.baseAppPath;
  }

  ngOnInit(): void {
    this.data.getToken();
    this.init();
  }

  init() {
    // if(updateUsername){

    // }
    this.storage.get("userData").then((val) => {
      // 
      if (val !== null && val !== '' && val !== undefined) {
        this.user = val;
        this.loginNameUser = this.user;
        this.loginName = this.user;
        console.log(this.loginName);
      }
    });
    this.storage.get("loginInfo").then((val) => {
      if (val !== null && val !== '' && val !== undefined) {
        this.member = val.iMember;
        this.loginNameMember = this.member;
        this.loginName = this.member;
        console.log(this.loginName);

        // console.log(this.user,);
      }
    });
  }
  confirmLogout() {
    const dialogRef = this.dialog.open(CommonAlertComponent, {
      width: "350px",
      disableClose: true,
      data: {
        msg: "Are you sure you want to logout ?",
        trueBtnText: "Yes",
        trueBtnColor: "danger",
        trueRaised: true,
        falseBtnText: "No",
        falseRaised: false,
        falseBtnColor: "medium",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.logout();
      }
    });
  }
  logout() {
    sessionStorage.clear();
    this.storage.clear();
    window.location.assign(this.baseAppPath);
  }
  openChangePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: "400px",
      height: "450px",
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.logout();
      }
    });
  }
}
